import keymirror from 'keymirror';

export default keymirror({
  loginInProgress: null,
  loginSuccess: null,
  loginFail: null,
  SignupInProgress: null,
  SignupSuccess: null,
  SignupFail: null,
  homepageSuccess: null,
  homepageFail: null,
  homepageInProgress: null,
  logout: null,
  followSuccess: null,
  followInProgress: null,
  followFail: null,
  unfollowSuccess: null,
  unfollowInProgress: null,
  unfollowFail: null,
  likeSuccess: null,
  likeInProgress: null,
  likeFail: null,
  dislikeSuccess: null,
  dislikeInProgress: null,
  dislikeFail: null,
  addTweetSuccess: null,
  addTweetInProgress: null,
  addTweetFail: null,
  refreshSuccess: null,
  refreshFail: null,
  refreshInProgress: null,
});
